<!--
 * @Description: 
 * @Author: yangsibo
 * @Date: 2022-09-28 16:41:44
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-09-28 16:41:49
 * @FilePath: /adm.xiangli360.com/src/views/County/CountyManage/index.vue
-->
<template>
    <router-view />
</template>

<script>
export default {
    name: "CountyManage",
};
</script>